
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/pedido.vue';
    import movil from './pc/pedido.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {
        created()
        {

        }


    }
